const toBoolean = value => value === true || value === 'true'

export const stubIsEnabled = () =>
  typeof window !== 'undefined' ? toBoolean(window.stubEnabled) : toBoolean(process.env.STUB_ENABLED)
